import { Slice } from '@reduxjs/toolkit';
import { ModelContext, ModelMap } from '../common/types/models';
import { GenericCRUDActions, CrudActionEssential } from './crud.actions';
import { createCollectionSlice } from './generic.slice';
import { ReduxState, ReduxStateKeys } from './store.interface';

const sliceName: ReduxStateKeys = 'creatives';
type SliceType = ReduxState[typeof sliceName];
type ModelType = ModelMap[ModelContext.CREATIVE];

const initialState: SliceType = [];

export const {
  readById,
  readAll,
  createRecord,
  updateRecord,
  deleteRecord,
}: CrudActionEssential<ModelType> = new GenericCRUDActions<ModelType>(
  sliceName,
);
const crudActions: CrudActionEssential<ModelType> = {
  readById,
  readAll,
  createRecord,
  updateRecord,
  deleteRecord,
};
const creatives: Slice<ModelType[]> = createCollectionSlice<ModelType>({
  name: sliceName,
  initialState,
  crudActions,
});

export const { add, replaceAll, update, remove } = creatives.actions;
export default creatives.reducer;
